// @ actions
const actionTypes = require('constants/actionTypes');
// @ helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

const emitedTransfersLiquidationsSuccess = (liquidations, accountId, transferId) => ({
    type: actionTypes.FETCH_EMITED_TRANSFER_LIQUIDATIONS_SUCCESS,
    payload: {
        accountId,
        liquidations,
        transferId
    }
});

const emitedTransfersLiquidationsFailure = (error, accountId, transferId) => ({
    type: actionTypes.FETCH_EMITED_TRANSFER_LIQUIDATIONS_FAILURE,
    payload: {
        accountId,
        error,
        transferId
    }
});

const emitedTransfersLiquidationsRequest = (accountId, transferId) => ({
    type: actionTypes.FETCH_EMITED_TRANSFER_LIQUIDATIONS_REQUEST,
    payload: {
        transferId,
        accountId
    }
});

function getEmitedTransfersLiquidations(dispatch, immTransaction) {
    const params = {
        query: {
            refProducto: immTransaction.getIn(['reference', 'producto']),
            refNumeroDeOrden: immTransaction.getIn(['reference', 'numerodeorden']),
            refCentro: immTransaction.getIn(['reference', 'center']),
            refEmpresa: immTransaction.getIn(['reference', 'enterprise'])
        }
    };

    const accountId = immTransaction.get('accountId');
    const transferId = immTransaction.get('id');

    dispatch(emitedTransfersLiquidationsRequest(accountId, transferId));
    return APIGet(dispatch, apiURLBuilder.getURL('emitedTransfersLiquidations'), params)
        .then(response => dispatch(emitedTransfersLiquidationsSuccess(response, accountId, transferId)))
        .catch(response => {
            if (!!response.error) {
                dispatch(emitedTransfersLiquidationsFailure(response.error.description, accountId, transferId))
            } else {
                throw response;
            }
        });
}

const requestEmitedTransfersLiquidations = immTransaction => (dispatch) => {
    return getEmitedTransfersLiquidations(dispatch, immTransaction);
}

module.exports = {
    requestEmitedTransfersLiquidations
};
